import angular from 'angular';
import ComponentsModule from '../components-module';
import template from './code-structure-tree-node.html';
import processNode from './process-node';

const COMPONENT_NAME = 'codeStructureTreeNode';

angular.module (ComponentsModule)
  .directive (COMPONENT_NAME, ($location, $route, $timeout, Application, ContentEditor, StructureService)  => {
    return {
      template,

      scope: {
        'node': '<',
        'isOpen': '<'
      },
      link: ($scope) => {
        if ($scope.node.error) {
          $scope.error = true;
        }
      }, 

      controller: function ($scope, $element) {
        $scope.isOpen = !!$scope.isOpen || false;
        $scope.isLoading = false;
        $scope.error = $scope.node.error;

        $scope.isExpandable = $scope.node.structure.length > 0 || $scope.node['structureOmitted'] === true;

        if ($scope.isExpandable) {
          $element.addClass('has-children');
        }

        $scope.showError = (error) => {
          Application.currentErrorInfo = { error };
          if ($location.path() === '/error') {
            $route.reload();
          } else {
            $location.path('/error');
          }
        };

        $scope.toggleOpen = function () {
          $scope.isOpen = !$scope.isOpen;

          if ($scope.node['structureOmitted'] === false || $scope.isLoading === true) {
            return;
          }

          let inProgress = true;

          $timeout(() => {
            if (inProgress) {
              $scope.isLoading = true;
            }
          }, 150);

          StructureService.getContentStructure({ alias: $scope.node.id })
            .then(response => {
              if (response.statusCode !== 200) {
                throw atex.aceui.error.Error({
                  type: atex.aceui.error.types.RUNTIME,
                  severity: atex.aceui.error.severities.MINOR,
                  origin: COMPONENT_NAME,
                  cause: response.statusMessage || 'Error loading structure'
                });
              }
              
              $scope.node = response;
              $scope.node.structure = ($scope.node.structure || []).map (processNode);
              inProgress = false;
              $scope.isLoading = false;
            })
            .catch(error => {
              console.error ('ERROR:', error);
              $scope.node = { name: error.cause, error };
              $scope.error = error;
            })
            .then(() => {
              inProgress = false;
              $scope.isLoading = false;
            });
        };

        $scope.openNode = function (node) {
          if (node.error) {
            $scope.showError(node.error);
          } else {
            ContentEditor.openContent(node.id);
          }
        };
      }
    };
  });
